import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { uploadResume } from "@/lib/api";
import { buildResumeFormData, validateResumeFile } from "./resumeUploadModel";

export function useResumeUpload({ source, name, email, phone }) {
  const [file, setFile] = useState(null);
  const [consent, setConsent] = useState(false);
  const [jd, setJd] = useState("");
  const [showJd, setShowJd] = useState(false);
  const [status, setStatus] = useState("idle");
  const [result, setResult] = useState(null);
  const inputRef = useRef(null);
  const requestVersion = useRef(0);
  useEffect(() => () => { requestVersion.current += 1; }, []);

  const clearFile = () => {
    requestVersion.current += 1;
    setFile(null);
    setResult(null);
    setStatus("idle");
    if (inputRef.current) inputRef.current.value = "";
  };
  const pick = (selectedFile) => {
    if (!selectedFile) return;
    const error = validateResumeFile(selectedFile);
    if (error) { toast.error(error); return; }
    requestVersion.current += 1;
    setFile(selectedFile);
    setResult(null);
    setStatus("idle");
  };
  const submit = async () => {
    if (!file || !consent || status === "uploading") return;
    const version = ++requestVersion.current;
    setStatus("uploading");
    try {
      const response = await uploadResume(buildResumeFormData({ file, source, name, email, phone, jd }));
      if (version !== requestVersion.current) return;
      setResult(response);
      setStatus("done");
    } catch (error) {
      if (version !== requestVersion.current) return;
      setStatus("error");
      toast.error(error?.response?.data?.detail || "Upload failed. Please try again.");
    }
  };
  return { file, consent, setConsent, jd, setJd, showJd, setShowJd, status, result,
    inputRef, clearFile, pick, submit };
}